// @intent: Normalize verified generated code into browser-importable JavaScript.
// @flow: ProjectBody.code -> toExecutableGeneratedCode -> Blob dynamic import in PixiRuntimeCanvas.
// @stale: Replace with server-side code artifact compilation when exports/build delivery becomes real.

const TYPE_ONLY_IMPORT_LINE = /^\s*import\s+type\s+[^;\n]+;?\s*$/gm;
const SETUP_API_TYPE_ANNOTATION = /(\bsetup\s*\(\s*api)\s*:\s*[^),]+/g;

export function toExecutableGeneratedCode(code: string): string {
  return code
    .replace(TYPE_ONLY_IMPORT_LINE, '')
    .replace(SETUP_API_TYPE_ANNOTATION, '$1');
}
